import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useKSK2101_R01Store } from "./Store_KSK2101_R01";
import { useInitUserSearchFilter } from "src/hooks/useInitUserSearchFilter";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_KSK2101_R01 } from "./Content_KSK2101_R01";
import { SearchSection_KSK2101_R01 } from "./SearchSection_KSK2101_R01";
import { Table_KSK2101_R01 } from "./Table_KSK2101_R01";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { KSK2101_R01Dto } from "./Dto_KSK2101_R01";

export const Container_KSK2101_R01 = () => {
    const { initData, KSK2101_R01Filter, setKSK2101_R01Filter } = useKSK2101_R01Store();
    const { setMessage } = useUiuxStore();
    useInitUserSearchFilter(setKSK2101_R01Filter, KSK2101_R01Filter);
    const gridRef = useRef<AgGridReact<KSK2101_R01Dto>>(null);

    const {
        fetchData,
    } = Content_KSK2101_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined}
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={() => {}}
            />
            <SearchSection_KSK2101_R01 onEnterKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === 'Enter') {
                    fetchData()
                }
            }} />
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    <Table_KSK2101_R01 gridRef={gridRef} />
                </div>
            </div>
        </div>
    );
};


